import { Component, OnInit, OnDestroy } from '@angular/core';


import { LoadingService } from '../../_services/loading.service';
import { LoaderState } from './loader';
import { Subscription } from 'rxjs';


@Component({
    selector: 'ng-loading',
    templateUrl: 'loading.component.html',
    styleUrls: ['loading.component.css']
})
export class LoadingComponent implements OnInit {

    show = false;

    private subscription: Subscription;

    constructor(
        private LoadingService: LoadingService
    ) { }

    ngOnInit() { 
        this.subscription = this.LoadingService.loaderState
            .subscribe((state: LoaderState) => {
                this.show = state.show;
            });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}